module.exports = __webpack_public_path__ + "img/eye.08a21608.svg";